module.exports = __webpack_public_path__ + "static/media/microsoft.25e119b3.svg";